import {isServer, useQuery} from '@tanstack/react-query'
import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import {MRT_API_BASEPATH} from '../../ssr/constants'
import {useLocation} from 'react-router-dom'

const useAwinRef = () => {
    const location = useLocation()
    let awc = ''

    //sv1=affiliate
    //&sv_campaign_id=45628
    // &awc=22910_1738149975_1d7401dcd43e578e602b518e7116da93
    // &sn=1&utm_source=aw
    // &utm_medium=affiliation_CH&utm_campaign=https%3A%2F%2Fwww.awin.com

    const urlParams = new URLSearchParams(location.search)
    awc = urlParams.get('awc') || ''
    awc = String(awc)

    const appOrigin = getAppOrigin()
    const shouldFetch = Boolean(awc) && !isServer
    return useQuery(
        ['useAwinRef', awc],
        async () => {
            const response = await fetch(
                `${appOrigin}${MRT_API_BASEPATH}/affiliation-awin/ref?awc=${awc}`,
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            )

            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`)
            }
            return response.json()
        },
        {
            enabled: shouldFetch,
            retry: false,
        },
    )
}

export default useAwinRef
